import { useProduct } from "../../context/ProductContext";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useCompare } from "../../hooks/useCompare";
import { T } from '../../utils/I18n/I18n';

const AddToCompare = () => {
    const { t } = useTranslation();
    const product = useProduct();
    const { addToCompare, compareProducts, removeCompare } = useCompare();
    const isInCompare = compareProducts.find((_product) => _product.sku === product.sku) !== undefined;

    const changeHandler = () => {
        const _product = {
            id: product.id,
            sku: product.sku,
            uid: product.uid,
            thumbnail: product.thumbnailImage.url,
            name: product.name,
            canonical_url: product.canonical_url,
        };
        if (isInCompare) {
            removeCompare(_product.sku);
        } else {
            addToCompare(_product);
        }
    };

    if (compareProducts.length >= 3 && !isInCompare) {
        return null;
    }

    return (
        <div className="product-item__compare-link">
            <div className="product-item__compare-icon-wrap">
                <label>
                    <input
                        type="checkbox"
                        checked={isInCompare}
                        onChange={changeHandler}
                        aria-label={isInCompare ? t('compare.removeFromCompare') : t('compare.addToCompare')}
                    />
                    <T id="Compare" />
                </label>
            </div>
        </div>
    );
};

export default AddToCompare;